import { openAlertModal } from 'admin/actions/alert-modal';
import {
  CLEAR_SELECTED_PAYREGI_IDS,
  getPayregis,
  reAssignPayregi,
  SET_SELECTED_PAYREGI_IDS,
  unAssignPayregi,
} from 'admin/actions/devices';
import { getOrganizations } from 'admin/actions/organization';
import { getPrivateMoneys } from 'admin/actions/private-moneys';
import { clearShopAccounts, clearShops, getShopAccounts, getShops } from 'admin/actions/shops';
import CheckBox from 'admin/components/atoms/CheckBox';
import _Label from 'admin/components/atoms/Label';
import {
  addNullOption,
  default as Select,
  default as _Select,
} from 'admin/components/atoms/Select';
import Table from 'admin/components/atoms/Table';
import SelectedPrivateMoneyDisplay from 'admin/components/organisms/SelectedPrivateMoneyDisplay';
import Pager from 'admin/components/shared/Pager';
import ProgressBar from 'admin/components/shared/ProgressBar';
import { getFrontEnv, toQueryParams } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { semanticColors, theme } from 'admin/theme';
import Button from '../../../atoms/Buttons';
import FilterForm from './FilterForm';
import { PayregiConnector } from 'admin/utils/devices/payregi/connector';
import { Environment } from 'admin/utils/devices/payregi/packet';
import serial from 'admin/utils/devices/serial';
import DeviceSlider from 'admin/components/atoms/DeviceSlider';
import volumeSvg from 'admin/icons/volume.svg';
import brightnessSvg from 'admin/icons/brightness.svg';
import networkSvg from 'admin/icons/network.svg';
import Loader from 'admin/components/atoms/Loader';
import ErrorMessageComponent from 'admin/components/atoms/ErrorMessage';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const ProcessingButton = styled(Button)`
  margin-top: 0.5rem;
  &:disabled {
    background: #009239 !important;
    opacity: 0.5 !important;
    color: white;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const DeviceTableCheckbox = styled(CheckBox)`
  width: 14px;
  height: 14px;
  border: 1px solid #666;
  border-radius: 4.5px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  position: relative;

  &:checked {
    background-color: ${(props) => (props.isConnected ? theme.colors.gray['200'] : '#2684ff')};
    border-color: ${(props) => (props.isConnected ? theme.colors.gray['200'] : '#2684ff')};
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 1.5px;
    width: 4px;
    height: 7px;
    border: solid white;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }
`;

const ListTableBox = styled.div`
  flex-grow: 1;
  min-width: 60%;
`;

const SettingBox = styled.div`
  flex-grow: 1;
  margin: 0 20px 20px 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  align-self: flex-start;
  position: sticky;
  top: 5rem;
  .counting {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button-group {
      display: flex;
      gap: 0.5rem;
    }
    span {
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
  ${_Select} {
    width: 400px;
  }
  ${_Label} {
    margin: 0;
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.75rem 0;
`;

const NoResultText = styled.span`
  font-weight: 600;
  font-size: 16px;
  padding: 10px;
  text-align: center;
  display: block;
`;

const NoResultSecondaryText = styled.span`
  font-size: 14px;
  color: ${semanticColors.text.secondary};
  padding: 10px;
  text-align: center;
  display: block;
`;

const HEADERS = [
  { label: '', size: 0.5 },
  { label: 'シリアル番号', size: 2.5 },
  { label: 'ハードウェアver', size: 3 },
  { label: 'マネー名', size: 2 },
  { label: '組織名', size: 2 },
  { label: '店舗名', size: 2 },
];

const DeviceRow = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const DeviceLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
`;

const DEFAULT_SOUND = 7;
const DEFAULT_BRIGHTNESS = 7;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
`;

class Payregis extends Component {
  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 25 };

    const params = new URLSearchParams(props.location.search);
    const moneyName = params.get('moneyName') || '';
    const shopName = params.get('shopName') || '';
    const terminalUuid = params.get('terminalUuid') || '';
    const serialNumber = params.get('serialNumber') || '';
    const pcbVer = props.defaultPcbVer || [];

    this.prConn = new PayregiConnector({
      onDeviceDisconnected: () => {
        this.resetDisconnectedState();
      },
    });
    this.state = {
      form: {
        moneyName,
        shopName,
        terminalUuid,
        serialNumber,
        pcbVer,
      },
      selectedOrgOption: {
        value: '',
      },
      selectedShopOption: {
        value: '',
      },
      checkingAll: false,
      lastCheckingId: null,
      shiftKeyPressed: false,
      checkingPayregiIds: new Set([]),
      connectedPayregi: {
        id: null,
        serialNumber: null,
        environment: null,
      },
      processingAssignment: false,
      processingAssignmentCount: 0,
      currentPage: 1,
      organizations: { rows: [] },
      moneys: { rows: [] },
      isNewPayRegi: props.defaultPcbVer?.includes('v7'),
      sound: DEFAULT_SOUND,
      new_sound: DEFAULT_SOUND,
      brightness: DEFAULT_BRIGHTNESS,
      new_brightness: DEFAULT_BRIGHTNESS,
      hasConnectedDevice: false,
      pendingDeviceSelection: null,
      pendingEnvironmentCheck: null,
      processingDeviceConnection: false,
      deviceConnectionError: false,
    };
  }

  componentDidMount() {
    this.props.clearShopAccounts();

    const userPrivateMoney = this.getUserPrivateMoney();
    if (userPrivateMoney && userPrivateMoney.id) {
      const params = toQueryParams(
        {
          page: 1,
          perPage: 10000,
          privateMoneyId: userPrivateMoney.id,
        },
        true
      );
      this.props.getOrganizations(params);
    }
  }

  componentWillMount() {
    if (this.props.user.role.match(/^SERVICE.*/)) {
      const query = toQueryParams({ per_page: 2000 });
      getPrivateMoneys(query)
        .then((json) => {
          this.setState({
            moneys: json,
          });
        })
        .catch((e) => {
          console.error('An error occurred in listing private moneys: ', e);
        });
    } else {
      this.setState({
        moneys: {
          rows: this.props.user.issuedMoneys(),
        },
      });
    }

    this.fetchPayregis();

    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('keyup', this.onKeyUp);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.payregis !== prevProps.payregis ||
      this.props.selectedPayregiIds !== prevProps.selectedPayregiIds
    ) {
      const selectedIds = new Set(this.props.selectedPayregiIds);
      this.setState({
        checkingAll: this.props.payregis.rows.every((p) => selectedIds.has(p.id)),
      });
    }

    if (this.props.organizations !== prevProps.organizations) {
      const userOrganization = this.props.user.organization;
      const { organizations } = this.props;
      if (userOrganization && !organizations.rows.find((o) => o.code === userOrganization.code)) {
        const combinedOrganizations = {
          ...organizations,
          rows: [userOrganization, ...organizations.rows],
        };
        this.setState({ organizations: combinedOrganizations });
      } else {
        this.setState({ organizations });
      }
    }
    if (this.props.userPrivateMoney !== prevProps.userPrivateMoney) {
      const userPrivateMoney = this.props.userPrivateMoney;
      if (userPrivateMoney && userPrivateMoney.id) {
        const params = toQueryParams(
          {
            page: 1,
            perPage: 10000,
            privateMoneyId: userPrivateMoney.id,
          },
          true
        );
        this.props.getOrganizations(params);
        this.props.clearShopAccounts();

        this.setState({
          selectedOrgOption: { value: '' },
          selectedShopOption: { value: '' },
        });
      }
    }

    if (this.state.pendingDeviceSelection && prevProps.payregis !== this.props.payregis) {
      const serialNumber = this.state.pendingDeviceSelection;
      const matchingDevice = this.props.payregis.rows.find(
        (device) => device.serial_number === serialNumber
      );

      if (matchingDevice) {
        this.setState({
          checkingPayregiIds: new Set([matchingDevice.id]),
          connectedPayregi: {
            ...this.state.connectedPayregi,
            id: matchingDevice.id,
          },
          pendingDeviceSelection: null,
        });
        this.props.setSelectedPayregiIds([matchingDevice.id]);

        // Check environment mismatch only after confirming device exists
        if (this.state.pendingEnvironmentCheck !== null) {
          this.handleEnvironmentMismatch(this.state.pendingEnvironmentCheck);
          this.setState({ pendingEnvironmentCheck: null });
        }
      } else {
        // Device not found - show modal and disconnect on close
        this.setState({
          checkingPayregiIds: new Set([]),
          pendingDeviceSelection: null,
          pendingEnvironmentCheck: null,
        });
        this.props.setSelectedPayregiIds([]);

        this.props.openAlertModal({
          body: (
            <div>
              <div>該当するデバイスはありません</div>
              <div style={{ color: theme.colors.gray['300'], fontSize: '14px', marginTop: '8px' }}>
                このデバイスは登録されていません。サポートにお問い合わせください。
              </div>
            </div>
          ),
          useCancel: false,
          confirmText: 'OK',
          confirmColor: 'danger',
          onConfirm: async () => {
            if (this.state.hasConnectedDevice) {
              await this.prConn.disconnect();
              this.resetDisconnectedState();
            }
          },
        });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('keyup', this.onKeyUp);
    this.props.clearShops();
    this.props.clearShopAccounts();
    if (this.errorTimeoutId) {
      clearTimeout(this.errorTimeoutId);
      this.errorTimeoutId = null;
    }
    if (this.prConn.isConnected()) {
      this.prConn.disconnect().catch((err) => console.error('Failed to disconnect:', err));
    }
  }

  resetDisconnectedState = () => {
    if (this.errorTimeoutId) {
      clearTimeout(this.errorTimeoutId);
      this.errorTimeoutId = null;
    }
    this.setState(
      {
        hasConnectedDevice: false,
        connectedPayregi: { id: null, serialNumber: null, environment: null },
        form: {
          moneyName: '',
          shopName: '',
          terminalUuid: '',
          serialNumber: '',
          pcbVer: this.props.defaultPcbVer,
        },
        brightness: DEFAULT_BRIGHTNESS,
        new_brightness: DEFAULT_BRIGHTNESS,
        sound: DEFAULT_SOUND,
        new_sound: DEFAULT_SOUND,
        pendingDeviceSelection: null,
        pendingEnvironmentCheck: null,
        processingDeviceConnection: false,
        deviceConnectionError: false,
        processingAssignment: false,
        processingAssignmentCount: 0,
      },
      () => {
        this.onSearch();
      }
    );
    this.props.setSelectedPayregiIds([]);
  };

  onKeyDown = (e) => {
    if (e.keyCode === 16) {
      this.setState({
        shiftKeyPressed: true,
      });
    }
  };

  onKeyUp = (e) => {
    if (e.keyCode === 16) {
      this.setState({
        shiftKeyPressed: false,
      });
    }
  };

  onSearch = () => {
    const params = new URLSearchParams(this.props.location.search);
    Object.keys(this.state.form).forEach((key) => {
      if (this.state.form[key]) {
        params.set(key, this.state.form[key]);
      } else {
        params.delete(key);
      }
    });

    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: params.toString(),
    });

    this.fetchPayregis();
  };

  onChangePage = (page) => {
    this.setState(
      {
        lastCheckingId: null,
        currentPage: page,
      },
      () => {
        this.fetchPayregis({
          page: page,
        });
      }
    );
  };

  onChangeForm = (e) => {
    const newForm = Object.assign({}, this.state.form, { [e.target.name]: e.target.value });
    this.setState({ form: newForm });
  };

  fetchPayregis(pagination) {
    const pageParams = Object.assign({}, this.defaultPagination, pagination);
    const params = Object.assign({}, this.state.form, pageParams);
    this.props.getPayregis(toQueryParams(params, true));
  }

  getUserPrivateMoney = () => {
    return this.props.userPrivateMoney;
  };

  onChangeOrganizationSelect = (op) => {
    if (!op.value) {
      this.resetSelectedOrgOption();
    } else if (this.state.selectedOrgOption.value !== op.value) {
      this.resetSelectedOrgOption();
      this.setState({ selectedOrgOption: op });
      const orgCode = op.value;
      const params = toQueryParams(
        {
          page: 1,
          perPage: 5000,
          organizationCode: orgCode,
        },
        true
      );
      this.props.getShops(params);
    }
  };

  onChangeShopSelect = (op) => {
    if (!op.value) {
      this.resetSelectedShopOption();
    } else if (this.state.selectedShopOption.value !== op.value) {
      this.resetSelectedShopOption();
      this.setState({ selectedShopOption: op });
      const shopId = op.value;

      const userPrivateMoney = this.getUserPrivateMoney();
      const params = toQueryParams(
        {
          privateMoneyId: userPrivateMoney?.id,
        },
        true
      );
      this.props.getShopAccounts(shopId, params);
    }
  };

  resetSelectedOrgOption = () => {
    this.setState({
      selectedOrgOption: { value: '' },
    });
    this.resetSelectedShopOption();
  };

  resetSelectedShopOption = () => {
    this.setState({
      selectedShopOption: { value: '' },
    });
  };

  onCheckPayregi = (id, state) => {
    const currentCheckedIndex = this.props.payregis.rows.findIndex((r) => r.id === id);
    if (currentCheckedIndex < 0) return;

    const selectedIds = new Set(this.props.selectedPayregiIds);
    let lastCheckedIndex = -1;

    if (this.state.shiftKeyPressed) {
      if (this.state.lastCheckingId !== null) {
        lastCheckedIndex = this.props.payregis.rows.findIndex(
          (r) => r.id === this.state.lastCheckingId
        );
      }
    }

    if (lastCheckedIndex >= 0) {
      const [start, end] =
        currentCheckedIndex > lastCheckedIndex
          ? [lastCheckedIndex, currentCheckedIndex]
          : [currentCheckedIndex, lastCheckedIndex];
      for (let i = start; i <= end; i += 1) {
        const iid = this.props.payregis.rows[i].id;
        if (state) {
          selectedIds.add(iid);
        } else {
          selectedIds.delete(iid);
        }
      }
    } else {
      if (state) {
        selectedIds.add(id);
      } else {
        selectedIds.delete(id);
      }
    }

    this.props.setSelectedPayregiIds(Array.from(selectedIds));

    this.setState({
      checkingAll: this.props.payregis.rows.every((r) => selectedIds.has(r.id)),
      lastCheckingId: id,
    });
  };

  onCheckAll = (state) => {
    const selectedIds = new Set(this.props.selectedPayregiIds);

    if (state) {
      this.props.payregis.rows.forEach((r) => {
        selectedIds.add(r.id);
      });
    } else {
      this.props.payregis.rows.forEach((r) => {
        selectedIds.delete(r.id);
      });
    }

    this.props.setSelectedPayregiIds(Array.from(selectedIds));

    this.setState({
      checkingAll: state,
    });
  };

  onClearAllCheck = async () => {
    if (this.state.hasConnectedDevice) {
      await this.prConn.disconnect();
      this.resetDisconnectedState();
    } else {
      this.props.clearSelectedPayregiIds();

      this.setState({
        checkingAll: false,
      });
    }
  };

  onFinished = () => {
    this.props.openAlertModal({
      body: (
        <div>
          <div>完了しました</div>
          {this.state.hasConnectedDevice && this.props.selectedPayregiIds.length === 1 && (
            <div style={{ color: theme.colors.gray['300'], fontSize: '14px', marginTop: '8px' }}>
              デバイスをPCから安全に取り外すことができます。
            </div>
          )}
        </div>
      ),
      useCancel: false,
      confirmText: 'OK',
      onConfirm: () => {
        this.setState(
          {
            processingAssignment: false,
            processingAssignmentCount: 0,
            selectedOrgOption: { value: '' },
            selectedShopOption: { value: '' },
            form: { ...this.state.form, serialNumber: '' },
          },
          () => {
            this.onClearAllCheck();
            this.props.clearShopAccounts();
            this.prConn.onDeviceDisconnected();
            this.fetchPayregis({
              page: this.state.currentPage,
            });
          }
        );
      },
    });
  };

  onUnAssign = async () => {
    const selectedCount = this.props.selectedPayregiIds.length;
    this.props.openAlertModal({
      body: `${selectedCount}台のペイレジを在庫に戻します。よろしいですか？`,
      useCancel: true,
      confirmText: '在庫に戻す',
      onConfirm: async () => {
        this.setState({
          processingAssignment: true,
          processingAssignmentCount: 0,
        });
        const ids = [...this.props.selectedPayregiIds];
        const iter = () => {
          if (ids.length > 0) {
            const pid = ids.shift();
            this.props.unAssignPayregi(pid).then(() => {
              const count = this.state.processingAssignmentCount + 1;
              this.setState(
                {
                  processingAssignmentCount: count,
                },
                () => {
                  setTimeout(iter, 200);
                }
              );
            });
          } else {
            this.onFinished();
          }
        };
        iter();
        if (this.state.hasConnectedDevice) {
          await this.prConn.disconnect();
          this.resetDisconnectedState();
        }
      },
    });
  };

  // Switch device environment if it does not match the admin environment
  handleEnvironmentMismatch = (deviceEnvNumeric) => {
    const currentFrontEnv = getFrontEnv();
    if (currentFrontEnv === 'local') return;
    const envMapping = {
      production: Environment.PRODUCTION,
      sandbox: Environment.SANDBOX,
      topic1: Environment.TOPIC1,
      qa: Environment.QA,
      dev: Environment.DEVELOP,
      loadtest: Environment.LOADTEST,
    };

    const siteEnvNumeric = envMapping[currentFrontEnv];
    if (siteEnvNumeric !== undefined && deviceEnvNumeric !== siteEnvNumeric) {
      const targetEnvText =
        siteEnvNumeric === Environment.PRODUCTION
          ? '本番環境に切り替えますか？'
          : `テスト環境(${currentFrontEnv})に切り替えますか？`;

      this.props.openAlertModal({
        body: (
          <div>
            <div>ペイレジの環境が一致していません</div>
            <div style={{ color: theme.colors.gray['300'], fontSize: '14px', marginTop: '8px' }}>
              {targetEnvText}
            </div>
          </div>
        ),
        useCancel: true,
        confirmText: '切り替える',
        onCancel: async () => {
          await this.prConn.disconnect();
          this.resetDisconnectedState();
          this.onSearch();
        },
        onConfirm: () => {
          if (!this.state.hasConnectedDevice || !this.prConn.isConnected()) return;
          this.setState((prevState) => ({
            connectedPayregi: {
              ...prevState.connectedPayregi,
              environment: siteEnvNumeric,
            },
          }));
        },
      });
    }
  };

  waitForDeviceReconnect = async () => {
    await this.pollForDeviceReconnection();
  };

  pollForDeviceReconnection = async () => {
    const maxAttempts = 60; // 60 seconds timeout
    const pingTimeout = 2000; // 2 second timeout per ping
    console.info('Starting device reconnection polling...');

    this.setState({ processingDeviceConnection: true });

    try {
      for (let i = 0; i < maxAttempts; i++) {
        try {
          // Check if port is still connected before attempting ping
          if (!this.prConn.isConnected()) {
            break;
          }

          const pingPromise = this.prConn.ping();
          const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Ping timeout')), pingTimeout)
          );

          await Promise.race([pingPromise, timeoutPromise]);
          console.info('Device reconnected successfully');
          return;
        } catch (error) {
          // Check for USB disconnection errors
          if (
            error.message &&
            ['device has been lost', 'disconnected', 'The device has been lost'].some((msg) =>
              error.message.includes(msg)
            )
          ) {
            break;
          }
          await new Promise((r) => setTimeout(r, 1000));
        }
      }

      console.info('Device did not reconnect within timeout period');
      throw new Error('Device did not reconnect within 60 seconds');
    } finally {
      // Re-enable UI after reconnection (or failure)
      this.setState({ processingDeviceConnection: false });
    }
  };

  connectToDeviceWithRetry = async (maxRetries = 3) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        await this.prConn.requestConnection();
        this.setState({ processingDeviceConnection: true });

        if (this.prConn.isConnected()) {
          // Wait for device to be fully ready with polling
          await this.waitForDeviceReconnect();
          return true;
        }
      } catch (error) {
        if (error.name === 'NotFoundError' || error.name === 'AbortError') {
          throw new Error('USER_CANCELLED');
        }

        if (attempt < maxRetries) {
          await new Promise((r) => setTimeout(r, 2000));
        }
      }
    }
    return false;
  };

  onConfigureConnectedDevice = async () => {
    try {
      // The device might take some time to be ready after initial connection
      const connected = await this.connectToDeviceWithRetry();
      if (!connected) {
        throw new Error('Failed to connect to device after multiple attempts');
      }

      this.setState({ hasConnectedDevice: true });

      await new Promise((r) => setTimeout(r, 1000));

      let serialNumber;
      let retryCount = 0;
      const maxDataRetries = 5;

      // Retry getting device info if it fails (device might still be initializing)
      while (retryCount < maxDataRetries) {
        try {
          const { lcd_luminance, speaker_volume, app_env } = await this.prConn.getDeviceInfo();
          serialNumber = await this.prConn.getSerialNumber();

          if (!serialNumber) {
            this.props.openAlertModal({
              body: (
                <div>
                  <div>該当するデバイスはありません</div>
                  <div
                    style={{ color: theme.colors.gray['300'], fontSize: '14px', marginTop: '8px' }}
                  >
                    このデバイスは登録されていません。サポートにお問い合わせください。
                  </div>
                </div>
              ),
              useCancel: false,
              confirmText: 'OK',
              confirmColor: 'danger',
              onConfirm: () => {
                this.setState(
                  {
                    hasConnectedDevice: false,
                  },
                  () => {
                    this.onClearAllCheck();
                    this.props.clearShopAccounts();
                    this.prConn.onDeviceDisconnected();
                    this.fetchPayregis({
                      page: this.state.currentPage,
                    });
                  }
                );
              },
            });
            return;
          }

          this.setState(
            {
              form: {
                moneyName: '',
                shopName: '',
                terminalUuid: '',
                serialNumber: serialNumber,
              },
              connectedPayregi: { id: null, serialNumber, environment: app_env },
              brightness: lcd_luminance,
              new_brightness: lcd_luminance,
              sound: speaker_volume,
              new_sound: speaker_volume,
              pendingDeviceSelection: serialNumber,
              pendingEnvironmentCheck: app_env,
            },
            () => {
              this.onSearch();
            }
          );
          break;
        } catch (error) {
          retryCount++;
          if (retryCount < maxDataRetries) {
            await new Promise((r) => setTimeout(r, 1000));
          } else {
            throw error;
          }
        }
      }
    } catch (error) {
      console.error('Device connection error:', error);
      this.prConn.disconnect();

      if (error.message === 'USER_CANCELLED') {
        this.setState({
          hasConnectedDevice: false,
          deviceConnectionError: false,
        });
      } else {
        this.setState({
          hasConnectedDevice: false,
          deviceConnectionError: true,
        });

        if (this.errorTimeoutId) {
          clearTimeout(this.errorTimeoutId);
        }
        this.errorTimeoutId = setTimeout(() => {
          this.setState({ deviceConnectionError: false });
          this.errorTimeoutId = null;
        }, 5000);
      }
    } finally {
      this.setState({ processingDeviceConnection: false });
    }
  };

  onReAssignAccount = () => {
    // there will always be only 1 shop account, 1:1 relationship with money
    const shopAccount = this.props.shopAccounts[0];
    const aid = shopAccount.id;
    const name = shopAccount.name;
    const selectedCount = this.props.selectedPayregiIds.length;

    this.props.openAlertModal({
      body: `${selectedCount}台のペイレジを「${name}」に割り当てます。よろしいですか？`,
      useCancel: true,
      confirmText: '割り当てる',
      onConfirm: async () => {
        this.setState({
          processingAssignment: true,
          processingAssignmentCount: 0,
        });

        const ids = [...this.props.selectedPayregiIds];
        const iter = async () => {
          if (ids.length > 0) {
            const pid = ids.shift();
            await this.props.reAssignPayregi(pid, aid);
            const count = this.state.processingAssignmentCount + 1;
            this.setState(
              {
                processingAssignmentCount: count,
              },
              () => {
                setTimeout(iter, 200);
              }
            );
          } else {
            if (this.state.checkingPayregiIds.has(this.state.connectedPayregi.id)) {
              // After all assignments are done, if there's a connected device, update its settings to match the newly assigned account
              if (this.state.hasConnectedDevice && this.prConn.isConnected()) {
                await this.configureDeviceSettings();
              }
            } else {
              this.onFinished();
            }
          }
        };
        iter();
      },
    });
  };

  showDeviceSettingsErrorModal = () => {
    this.props.openAlertModal({
      body: (
        <div>
          <div>端末側の設定の書き込みに失敗しました</div>
          <div style={{ color: theme.colors.gray['300'], fontSize: '14px', marginTop: '8px' }}>
            デバイスを接続し直して、再度お試しください
          </div>
        </div>
      ),
      useCancel: false,
      confirmText: 'OK',
      confirmColor: 'danger',
      onConfirm: async () => {
        if (this.state.hasConnectedDevice && this.prConn.isConnected()) {
          await this.prConn.disconnect();
        }
        this.resetDisconnectedState();
      },
    });
  };

  configureDeviceSettings = async () => {
    try {
      const deviceSettingsSuccess = await this.prConn.setDeviceSettings({
        volume: this.state.new_sound,
        brightness: this.state.new_brightness,
        environment: this.state.connectedPayregi.environment,
        save: true,
      });
      const accountSettingSuccess = await this.prConn.fetchAndApplyAccountConfigToDevice();

      if (!deviceSettingsSuccess || !accountSettingSuccess) {
        this.showDeviceSettingsErrorModal();
        return;
      }

      this.onFinished();
    } catch (error) {
      console.error('Failed to configure device settings:', error);
      this.showDeviceSettingsErrorModal();
    }
  };

  handleVolumeChange = async (e) => {
    const newVolume = parseInt(e.target.value, 10);
    this.setState({ new_sound: newVolume });

    if (this.state.hasConnectedDevice && this.prConn.isConnected()) {
      try {
        await this.prConn.previewVolume(newVolume);
      } catch (error) {
        console.error('Failed to test sound:', error);
      }
    }
  };

  handleBrightnessChange = async (e) => {
    const newBrightness = parseInt(e.target.value, 10);
    this.setState({ new_brightness: newBrightness });

    if (this.state.hasConnectedDevice && this.prConn.isConnected()) {
      try {
        await this.prConn.previewLuminance(newBrightness);
      } catch (error) {
        console.error('Failed to test brightness:', error);
      }
    }
  };

  renderSettingBox() {
    const selectedCount = this.props.selectedPayregiIds.length;
    const connectButtonEnabled = serial.isWebSerialSupported() && !this.state.hasConnectedDevice;
    return selectedCount > 0 ? (
      <div style={{ flexGrow: 1, minWidth: '40%' }}>
        {this.state.isNewPayRegi && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '8px',
              marginRight: '20px',
              position: 'sticky',
              top: '1rem',
            }}
          >
            <Button
              onClick={this.onConfigureConnectedDevice}
              disabled={!connectButtonEnabled || this.state.processingDeviceConnection}
              variant={this.state.hasConnectedDevice ? 'warning' : 'primary'}
            >
              {this.state.processingDeviceConnection || this.state.hasConnectedDevice
                ? 'デバイス接続中'
                : 'デバイス接続'}
            </Button>
          </div>
        )}
        <SettingBox>
          <div className="counting">
            <span>
              {selectedCount === 1 && this.state.isNewPayRegi
                ? '店舗登録'
                : `${selectedCount}台を選択中`}
            </span>
            <div className="button-group">
              <Button
                disabled={this.state.processingAssignment}
                onClick={this.onClearAllCheck}
                variant="neutral"
              >
                選択をクリア
              </Button>
              {this.props.user.role.match(/^SERVICE.*/) ? (
                <Button
                  disabled={this.state.processingAssignment}
                  onClick={this.onUnAssign}
                  variant="danger"
                >
                  在庫に戻す
                </Button>
              ) : null}
            </div>
          </div>
          <hr />
          <SelectedPrivateMoneyDisplay valueTextStyles={{ fontWeight: 'bold', opacity: 1 }} />
          <SelectWrapper>
            <span>組織名</span>
            <Select
              options={addNullOption(
                this.state.organizations.rows.map((org) => ({
                  label: org.name,
                  value: org.code,
                }))
              )}
              value={this.state.selectedOrgOption.value ? this.state.selectedOrgOption : null}
              onChange={this.onChangeOrganizationSelect}
              placeholder="「組織」を選択"
            />
          </SelectWrapper>
          <SelectWrapper>
            <span>店舗名</span>
            <Select
              span={<span>店舗名</span>}
              options={addNullOption(
                this.props.shops.rows.map((shop) => ({
                  label: shop.name,
                  value: shop.id,
                }))
              )}
              value={this.state.selectedShopOption.value ? this.state.selectedShopOption : null}
              onChange={this.onChangeShopSelect}
              placeholder="「店舗」を選択"
            />
          </SelectWrapper>
          {selectedCount === 1 && this.state.isNewPayRegi && this.state.hasConnectedDevice && (
            <>
              <hr />
              <SelectWrapper>
                <span>ペイレジ端末設定</span>
                {this.state.hasConnectedDevice && (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '16px',
                        marginBottom: '8px',
                      }}
                    >
                      <img
                        src={networkSvg}
                        alt={networkSvg}
                        style={{
                          width: '16px',
                          height: '16px',
                          marginRight: '8px',
                        }}
                      />
                      <span>接続環境</span>
                    </div>
                    {this.state.connectedPayregi.environment && (
                      <span>
                        {this.prConn.getEnvironment(this.state.connectedPayregi.environment)}
                      </span>
                    )}
                  </>
                )}
                <DeviceRow>
                  <DeviceLabel>
                    <img src={volumeSvg} alt="Volume" width="16" height="16" />
                    音量
                  </DeviceLabel>
                  <DeviceSlider
                    value={this.state.new_sound}
                    onChange={this.handleVolumeChange}
                    disabled={!this.state.hasConnectedDevice}
                  />
                </DeviceRow>
                <DeviceRow>
                  <DeviceLabel>
                    <img src={brightnessSvg} alt="Brightness" width="16" height="16" />
                    明るさ
                  </DeviceLabel>
                  <DeviceSlider
                    value={this.state.new_brightness}
                    onChange={this.handleBrightnessChange}
                    disabled={!this.state.hasConnectedDevice}
                  />
                </DeviceRow>
              </SelectWrapper>
            </>
          )}
          {this.state.processingAssignment ? (
            <div>
              <ProcessingButton variant="contained" disabled>
                しばらくお待ち下さい...
              </ProcessingButton>
              <ProgressBar
                unit="台"
                prefix="割当中"
                max={selectedCount}
                showMax
                current={this.state.processingAssignmentCount}
              />
            </div>
          ) : (
            <div>
              <ProcessingButton
                onClick={this.onReAssignAccount}
                disabled={this.props.shopAccounts.length === 0}
                variant="contained"
              >
                割り当てる
              </ProcessingButton>
            </div>
          )}
        </SettingBox>
      </div>
    ) : (
      <div style={{ flexGrow: 1, minWidth: '40%' }}>
        {this.state.isNewPayRegi && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '8px',
              marginRight: '20px',
              position: 'sticky',
              top: '1rem',
            }}
          >
            <Button
              onClick={this.onConfigureConnectedDevice}
              disabled={!connectButtonEnabled || this.state.processingDeviceConnection}
              variant={this.state.hasConnectedDevice ? 'warning' : 'primary'}
            >
              {this.state.processingDeviceConnection || this.state.hasConnectedDevice
                ? 'デバイス接続中'
                : 'デバイス接続'}
            </Button>
          </div>
        )}
        <SettingBox>
          <NoResultText>ペイレジを選択してください</NoResultText>
          {this.state.isNewPayRegi && (
            <>
              <NoResultSecondaryText>
                USBケーブル接続後、「デバイス接続」を押してください
              </NoResultSecondaryText>
              <NoResultSecondaryText>※Google Chrome、Microsoft Edgeのみ対応</NoResultSecondaryText>
            </>
          )}
        </SettingBox>
      </div>
    );
  }

  render() {
    const shopRole = !!this.props.user.role.match(/^SHOP.*/);
    const selectedIds = new Set(this.props.selectedPayregiIds);
    const rows = this.props.payregis.rows;
    const hasSettingBox = !shopRole;

    return (
      <div>
        {this.state.deviceConnectionError && this.state.isNewPayRegi && (
          <ErrorMessageComponent
            icon={<FA icon={faExclamationCircle} />}
            message="デバイス接続に失敗しました。もう一度お試しください。"
          />
        )}
        <FlexWrapper>
          <div style={{ flexGrow: 1, minWidth: hasSettingBox ? '60%' : '100%' }}>
            <FilterForm
              onSearch={this.onSearch}
              onChangeForm={this.onChangeForm}
              {...this.state.form}
            />
          </div>
          {hasSettingBox && <div style={{ flexGrow: 1, minWidth: '40%' }} />}
        </FlexWrapper>
        {this.state.processingDeviceConnection && this.state.isNewPayRegi && (
          <div style={{ flexGrow: 1, minWidth: '100%' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: '8px',
                marginRight: '20px',
              }}
            >
              <Button onClick={this.onConfigureConnectedDevice} disabled={true} variant="primary">
                デバイス接続
              </Button>
            </div>
          </div>
        )}
        <FlexWrapper>
          {this.state.processingDeviceConnection && this.state.isNewPayRegi ? (
            <LoaderWrapper style={{ width: '100%', minHeight: '400px' }}>
              <Loader type="Oval" width={50} height={50} />
            </LoaderWrapper>
          ) : (
            <>
              <ListTableBox>
                {!rows || rows.length === 0 ? (
                  <NoResultText>結果がありません</NoResultText>
                ) : (
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        {!shopRole && (
                          <Table.Cell size={HEADERS[0].size}>
                            <DeviceTableCheckbox
                              disabled={
                                this.state.processingAssignment || this.state.hasConnectedDevice
                              }
                              setChecked={this.onCheckAll}
                              checked={this.state.checkingAll}
                            />
                          </Table.Cell>
                        )}
                        {HEADERS.slice(1).map((header, index) => (
                          <Table.Cell key={index} size={header.size}>
                            {header.label}
                          </Table.Cell>
                        ))}
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {rows.map((row) => {
                        const isConnected = this.state.connectedPayregi.id === row.id;
                        return (
                          <Table.Row
                            key={row.id}
                            styles={{
                              '& td': { padding: '0.75rem 16px' },
                              backgroundColor: isConnected
                                ? theme.colors.blue['100']
                                : 'transparent',
                            }}
                          >
                            {!shopRole && (
                              <Table.Cell>
                                <DeviceTableCheckbox
                                  disabled={
                                    this.state.processingAssignment || this.state.hasConnectedDevice
                                  }
                                  setChecked={(checked) => this.onCheckPayregi(row.id, checked)}
                                  checked={selectedIds.has(row.id)}
                                  isConnected={isConnected}
                                />
                              </Table.Cell>
                            )}
                            <Table.Cell ellipsis>
                              <Link to={`/settings/devices/payregi/${row.id}`}>
                                {row.serial_number}
                              </Link>
                            </Table.Cell>
                            <Table.Cell wordBreak="keep-all">{row.pcb_ver}</Table.Cell>
                            <Table.Cell ellipsis>{row.money_name}</Table.Cell>
                            <Table.Cell ellipsis>{row.organization_name}</Table.Cell>
                            <Table.Cell ellipsis>{row.shop_name}</Table.Cell>
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                    <Table.Footer>
                      <Table.Row noBorder>
                        <Table.Cell
                          colSpan={HEADERS.length}
                          align="center"
                          styles={{ paddingTop: '16px' }}
                        >
                          <Pager
                            pagination={this.props.payregis.pagination}
                            onChangePage={this.onChangePage}
                          />
                        </Table.Cell>
                      </Table.Row>
                    </Table.Footer>
                  </Table>
                )}
              </ListTableBox>
              {hasSettingBox && this.renderSettingBox()}
            </>
          )}
        </FlexWrapper>
      </div>
    );
  }
}

Payregis.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  defaultPcbVer: PropTypes.arrayOf(PropTypes.string),
  user: PropTypes.object.isRequired,
  getPayregis: PropTypes.func.isRequired,
  reAssignPayregi: PropTypes.func.isRequired,
  unAssignPayregi: PropTypes.func.isRequired,
  getOrganizations: PropTypes.func.isRequired,
  getShops: PropTypes.func.isRequired,
  getShopAccounts: PropTypes.func.isRequired,
  clearShopAccounts: PropTypes.func.isRequired,
  openAlertModal: PropTypes.func.isRequired,
  setSelectedPayregiIds: PropTypes.func.isRequired,
  clearSelectedPayregiIds: PropTypes.func.isRequired,
  payregis: PropTypes.shape({
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        serial_number: PropTypes.string,
        pcb_ver: PropTypes.string,
        status: PropTypes.string,
        shop_name: PropTypes.string,
        organization_name: PropTypes.string,
        money_name: PropTypes.string,
      })
    ),
    count: PropTypes.number,
    pagination: PropTypes.shape({
      current: PropTypes.number,
      per_page: PropTypes.number,
      max_page: PropTypes.number,
      has_prev: PropTypes.bool,
      has_next: PropTypes.bool,
    }),
  }),
  organizations: PropTypes.object,
  shops: PropTypes.object,
  shopAccounts: PropTypes.array,
  selectedPayregiIds: PropTypes.arrayOf(PropTypes.number),
  moneyName: PropTypes.string,
  userPrivateMoney: PropTypes.object,
};

Payregis.defaultProps = {
  defaultPcbVer: [],
  payregis: { rows: [], count: 0, pagination: { current: 1, per_page: 25 } },
  organizations: { rows: [] },
  shops: { rows: [] },
  shopAccounts: [],
  selectedPayregiIds: [],
  moneyName: '',
  userPrivateMoney: {},
};

const mapStateToProps = (state) => ({
  payregis: state.device.payregis,
  user: state.user,
  organizations: state.organization.organizations,
  shops: state.shop.shops,
  shopAccounts: state.shop.shop_accounts,
  userPrivateMoney: state.userPrivateMoney.selectedMoney,
  selectedPayregiIds: state.device.selectedPayregiIds,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPayregis,
      reAssignPayregi,
      unAssignPayregi,
      getOrganizations,
      getShops,
      clearShops,
      getShopAccounts,
      clearShopAccounts,
      openAlertModal,
      setSelectedPayregiIds: (ids) => dispatch(SET_SELECTED_PAYREGI_IDS(ids)),
      clearSelectedPayregiIds: () => dispatch(CLEAR_SELECTED_PAYREGI_IDS()),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Payregis);
